import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.elebyte.io';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Request interceptor: add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('partner_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: handle 401
let isRefreshing = false;
let refreshSubscribers = [];

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('partner_refresh_token');
      if (!refreshToken) {
        // No refresh token - redirect to login
        window.location.href = '/';
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve) => {
          refreshSubscribers.push((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            resolve(api(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const response = await axios.post(`${API_BASE_URL}/api/auth/refresh`, {
          refreshToken,
        });
        const newToken = response.data.idToken || response.data.accessToken;
        localStorage.setItem('partner_access_token', newToken);

        refreshSubscribers.forEach((cb) => cb(newToken));
        refreshSubscribers = [];
        isRefreshing = false;

        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        isRefreshing = false;
        refreshSubscribers = [];
        localStorage.removeItem('partner_access_token');
        localStorage.removeItem('partner_refresh_token');
        window.location.href = '/';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export const partnerAPI = {
  getTenants: () => api.get('/api/partner/tenants').then(r => r.data),
  assumeTenant: (tenantId) => api.post('/api/partner/assume-tenant', { tenant_id: tenantId }).then(r => r.data),
  getProfile: () => api.get('/api/partner/profile').then(r => r.data),
  updateProfile: (data) => api.put('/api/partner/profile', data).then(r => r.data),
  getAuditLog: (params) => api.get('/api/partner/audit-log', { params }).then(r => r.data),
  logout: () => api.post('/api/partner/logout').then(r => r.data),
};

export default api;
